import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';
import { IndexCompanyComponent } from '../index-company/index-company.component';
import { IndexNavGridComponent } from '../../components/index-nav-grid/index-nav-grid.component';
import { CoreService } from '../../../../services/core.service';
import { SocialAistateListService } from '../../../../services/social-ai-state-list.service';
import { AbstractControl, FormGroup, Validators, FormsModule, FormBuilder } from '@angular/forms';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { CreateUserComponent } from '../../create/create-user/create-user.component';
import { FooterGridComponent } from '../../components/footer-grid/footer-grid.component';

@Component({
  selector: 'app-index-users',
  standalone: true,
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonToggleModule,
    SectionGridComponent,
    IndexCompanyComponent,
    IndexNavGridComponent,
    FormsModule,
    MatSortModule,
    CreateUserComponent,
    FooterGridComponent
  ],
  templateUrl: './index-users.component.html',
  styleUrl: './index-users.component.scss'
})
export class IndexUsersComponent implements OnInit {

  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['id', 'name', 'email', 'role', 'status', 'created_at', 'actions'];
  companyID: number = 0;
  searchValue: string = "";
  totalItems = 0;
  pageSize = 12;
  isLoading = true;
  hasLoaded = false;
  showAddUserModal = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  sortField: string = 'name';
  sortDirection: string = 'asc';

  constructor(
    private coreService: CoreService,
    private fb: FormBuilder,
    private listState: SocialAistateListService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.companyID = params['company'];
      this.loadUsers(1);
    });

    if (this.listState.searchValue) {
      this.searchValue = this.listState.searchValue;
    }
  }

  loadUsers(page: number = 1) {
    this.listState.page = page;
    this.isLoading = true;

    this.coreService
      .getData('/manageAccount/users/index', {
        companyID: this.companyID,
        page,
        keyword: this.searchValue,
        sort: this.sortField,
        direction: this.sortDirection
      })
      .subscribe({
        next: (res: any) => {
          this.dataSource.data = res.data || [];
          this.totalItems = res.total;
          this.pageSize = res.per_page;
          this.hasLoaded = true;

          if (this.paginator) {
            this.paginator.pageIndex = res.current_page - 1;
            this.paginator.length = res.total;
            this.paginator.pageSize = res.per_page;
          }
        },
        error: (err) => {
          console.error('Load error:', err);
          this.dataSource.data = [];
          this.hasLoaded = true;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  editUser(user: any) {
    this.router.navigate(['/manage-account/edit-user', user.ID], {
    });
  }

  deleteUser(user: any) {
    console.log('Delete user:', user);
  }

  addNewUser() {
    console.log('Add new user clicked');
  }

  onSearchSubmit(value: string) {
    this.searchValue = value.trim();
    this.listState.searchValue = this.searchValue;
    this.loadUsers(1);
  }

  clearSearch() {
    this.searchValue = "";
    this.listState.searchValue = "";
    this.loadUsers(1);
  }

  onPageChange(event: any) {
    const newPage = event.pageIndex + 1;
    this.loadUsers(newPage);
  }

  onSortChange(sort: Sort) {
    this.sortField = sort.active;
    this.sortDirection = sort.direction || 'asc';
    this.loadUsers(1);
  }

  onUserCreated(data: any) {
    this.showAddUserModal = false;
    this.loadUsers(1);
  }

}
